import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BaseProvider } from './base-provider';
import { GlobalsService } from './globals.service';
import { LsHelperService } from './ls-helper.service';
import firebase from 'firebase/app';
import 'firebase/database';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./globals.service";
import * as i3 from "@angular/common/http";
import * as i4 from "./ls-helper.service";
export class InboxService extends BaseProvider {
    constructor(router, globals, http, ls) {
        super();
        this.router = router;
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.roles = [];
        this.showManagement = false;
        this.item = {};
        this.messageCount = 0;
        this.isLoading = false;
        this.baseUrl = "messaging";
    }
    loadMessagingCount() {
        //this.getCount();
        let userId = this.ls.get("userId");
        if (userId) {
            this.firebasedb = firebase
                .database()
                .ref('messaging/' + userId + '/info');
            this.firebasedb.on("value", (resp) => {
                this.getCount();
            });
        }
    }
    get() {
        this.isLoading = true;
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            var loginData = this.ls.get('loginData');
            this.http.get(this.url)
                .subscribe((data) => {
                this.isLoading = false;
                this.list = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getCount() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/count';
            var loginData = this.ls.get('loginData');
            this.http.get(this.url)
                .subscribe((data) => {
                this.messageCount = data.Data ? data.Data : 0;
            }, err => { reject(err); });
        });
    }
    updateSeen(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/seen/" + params.Id;
            this.http
                .put(this.url, params)
                .subscribe((data) => {
                resolve(data);
                this.messageCount--;
                this.gotoUrl(params);
            }, err => { reject(err); });
        });
    }
    gotoUrl(item) {
        var url = item.UriPathTemplate;
        url = url.replace("{0}", item.EntityId);
        this.router.navigate([url]);
    }
    clearInbox() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/clear";
            this.http
                .put(this.url, {})
                .subscribe((data) => {
                this.list = [];
                resolve(data);
            }, err => { reject(err); });
        });
    }
    deleteMessage(messageId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/${messageId}`;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                this.list = this.list.filter(function (e) {
                    return e.Id !== messageId;
                });
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
InboxService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InboxService_Factory() { return new InboxService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.GlobalsService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.LsHelperService)); }, token: InboxService, providedIn: "root" });
